import flow from 'lodash/flow';
import { AnalyticsSubject } from '@atlassian/jira-analytics-web-react/src';
import FavouriteButton from '@atlassian/jira-favourite-button/src';

export default flow(AnalyticsSubject('board'))(FavouriteButton);
